import styled from 'styled-components';

export const EmptyContainer = styled.div`
  box-shadow: 0 0 11px 0 rgba(0, 0, 0, 0.03);
  background-color: #fff;
  border-radius: 6px;
  padding: 60px 85px;
  max-width: 1069px;
`;

export const EmptyTitle = styled.h2`
  color: #007aff;
  font-size: 34px;
  margin: 0;
`;

export const EmptyText = styled.p`
  line-height: 24px;
  color: #1b1818;
  font-weight: 500;
  font-size: 19px;
  margin: 0;
`;
